/** `method?key=value&…` with each key and value encoded; undefined and null are left out. */
export function withQuery(method, params) {
  const query = Object.entries(params || {})
    .filter(([, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    )
    .join("&");

  return query ? `${method}?${query}` : method;
}
